/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { toUrlEncodedString } from '@/features/reviews/utils/toUrlEncodedString';

export const getStoreLocationUrl = (storeLocationParams: {
  name: string;
  googlePlaceId: string;
}) => {
  const googleMapsQuery = toUrlEncodedString({
    api: 1,
    query: storeLocationParams.name,
    query_place_id: storeLocationParams.googlePlaceId,
  });

  return 'https://www.google.com/maps/search/?' + googleMapsQuery;
};
